/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentParcelsParcelidReversePayment200,
  PostApiV1IndividualpaymentParcelsParcelidReversePayment400,
  PostApiV1IndividualpaymentParcelsParcelidReversePayment401,
  PostApiV1IndividualpaymentParcelsParcelidReversePayment500,
  PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidReversePayment.ts";

export const postApiV1IndividualpaymentParcelsParcelidReversePaymentPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReversePaymentPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentParcelsParcelidReversePayment200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReversePayment200>;

/**
 * @description Parcela não está paga
 */
export const postApiV1IndividualpaymentParcelsParcelidReversePayment400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReversePayment400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentParcelsParcelidReversePayment401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReversePayment401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentParcelsParcelidReversePayment500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReversePayment500>;

export const postApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponseSchema =
  z.lazy(
    () => postApiV1IndividualpaymentParcelsParcelidReversePayment200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentParcelsParcelidReversePaymentMutationResponse>;
